import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Paginator } from "primereact/paginator";
import React, { useMemo, useRef } from "react";
import PropTypes from "prop-types";

const AvrPhysTable = ({ page, pageSize, onPageChange, data, totalItems }) => {
    const legalTable = useRef();

    // Поддержка как массива, так и page-объекта с полем content
    const normalizedData = useMemo(() => {
        if (Array.isArray(data)) return data;
        if (data && Array.isArray(data.content)) return data.content;
        return [];
    }, [data]);

    const totalRecords = useMemo(() => {
        if (typeof totalItems === "number") return totalItems;
        if (data && typeof data.totalElements === "number") return data.totalElements;
        return 0;
    }, [data, totalItems]);

    // Generate a stable unique key per row to avoid duplicate key warnings in React
    const dataWithKeys = useMemo(() => {
        return normalizedData.map((row, idx) => ({
            ...row,
            // Compose a custom id from several fields + index to guarantee uniqueness
            _rowKey: [
                row?.transactionId ?? "noTxn",
                row?.clientOrderNum ?? "noOrder",
                row?.articul ?? "noArt",
                row?.payDate ?? "noDate",
                idx,
            ].join("_"),
        }));
    }, [normalizedData]);

    const refundBodyTemplate = (row) => (row?.refund ? "Да" : "Нет");
    const numberTemplate = (field) => (row) =>
        row?.[field] !== undefined && row?.[field] !== null
            ? Number(row[field]).toLocaleString("ru-RU")
            : "";
    return <div className="card">
        <DataTable
            ref={legalTable}
            value={dataWithKeys}
            className="p-datatable-customers"
            dataKey="_rowKey"
            rowHover
            emptyMessage="Данные не найдены"
            scrollable
        >
            <Column headerStyle={{ width: "160px" }} field="clientOrderNum" header="Номер заказа" sortable />
            <Column headerStyle={{ width: "240px" }} field="fullName" header="ФИО" sortable />
            <Column headerStyle={{ width: "160px" }} field="transactionId" header="ID транзакции" sortable />
            <Column headerStyle={{ width: "180px" }} field="payDate" header="Дата оплаты" sortable />
            <Column headerStyle={{ width: "260px" }} field="nameRu" header="Услуга" sortable />
            <Column headerStyle={{ width: "120px" }} field="cnt" header="Кол-во" body={numberTemplate("cnt")} sortable />
            <Column headerStyle={{ width: "140px" }} field="price" header="Цена" body={numberTemplate("price")} sortable />
            <Column headerStyle={{ width: "160px" }} field="amount" header="Сумма" body={numberTemplate("amount")} sortable />
            <Column headerStyle={{ width: "140px" }} field="articul" header="Артикул" sortable />
            <Column headerStyle={{ width: "140px" }} field="refund" header="Возврат" body={refundBodyTemplate} sortable />
        </DataTable>
        <Paginator
            currentPageReportTemplate="Показано с {first} по {last} из {totalRecords} записей"
            template="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
            first={page * pageSize}
            rows={pageSize}
            totalRecords={totalRecords}
            rowsPerPageOptions={[10, 25, 50, 100]}
            onPageChange={onPageChange}
        />
    </div>
}

AvrPhysTable.propTypes = {
    page: PropTypes.number.isRequired,
    pageSize: PropTypes.number.isRequired,
    onPageChange: PropTypes.func.isRequired,
    // data: может быть массивом или page-объектом с { content, totalElements }
    data: PropTypes.oneOfType([
        PropTypes.array,
        PropTypes.shape({
            content: PropTypes.array,
            totalElements: PropTypes.number,
        }),
    ]).isRequired,
    totalItems: PropTypes.number,
}

export default AvrPhysTable;